import React from "react"
import {Box, Chip, Typography} from "@mui/material"
import styled from "styled-components"

import {phraseCaseAttentionState, type AttentionStateName, type CaseWait} from "./caseAttentionState"

import type {CaseWaitParty} from "@indebted/api"
import {colors} from "@indebted/theme/colors"

function CaseAttentionChip({case: caseWait, waitParties}: {case: CaseWait; waitParties: CaseWaitParty[]}) {
	const state = phraseCaseAttentionState(caseWait, waitParties)

	return (
		<Box display="flex" alignItems="center" gap={0.5}>
			<AttentionStateChip label={state.Label} $state={state.Name} />
			{state.Detail && (
				<Typography variant="body2" color="textSecondary">
					{state.Detail}
				</Typography>
			)}
		</Box>
	)
}

const attentionStateColors: Record<AttentionStateName, {background: string; border: string; text: string}> = {
	"waiting-with-deadline": {background: colors.blue["50"], border: colors.blue["200"], text: colors.blue["700"]},
	"waiting-overdue": {background: colors.warning["50"], border: colors.warning["200"], text: colors.warning["700"]},
	"waiting-open-ended": {background: colors.gray["50"], border: colors.gray["300"], text: colors.gray["600"]},
	"needs-attention": {background: colors.error["50"], border: colors.error["200"], text: colors.error["700"]},
}

const AttentionStateChip = styled(Chip).attrs({size: "small", variant: "outlined"})<{$state: AttentionStateName}>`
	&& {
		background-color: ${({$state}) => attentionStateColors[$state].background};
		border-color: ${({$state}) => attentionStateColors[$state].border};
		color: ${({$state}) => attentionStateColors[$state].text};
	}
	font-weight: 500;
`

export {CaseAttentionChip}
